import bannerImg from './banners/woman-helping-man-gym.jpg';


const anamnese = (t) => ({
    id: 'anamnese',
    title: t('templates.items.anamnese.title'),
    description: t('templates.items.anamnese.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 2,
    questionsSummary: [
        t('templates.items.anamnese.summary.mainGoal'),
        t('templates.items.anamnese.summary.currentWeight'),
        t('templates.items.anamnese.summary.trainingExperience'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.anamnese.form.title'),
        active: false,
        allow_multiple_answers: true,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.anamnese.form.goals.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamnese.form.goals.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'text',
                        label: t('templates.items.anamnese.form.goals.mainGoal.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'weight',
                        label: t('templates.items.anamnese.form.goals.currentWeight.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.anamnese.form.currentStage.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamnese.form.currentStage.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: t('templates.items.anamnese.form.currentStage.experience.label'),
                        description: null,
                        required: true,
                        settings: {
                            max: 5,
                            min: 1,
                            maxLabel: t('templates.items.anamnese.form.currentStage.experience.maxLabel'),
                            minLabel: t('templates.items.anamnese.form.currentStage.experience.minLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default anamnese;
